import { isEmpty } from 'lodash-es';
import { Controller } from "stimulus"
import moment from 'moment';
import sweet_alert from '../entrypoints/src/admin/utilities/sweet_alert';
import BatchScheduleService from '../entrypoints/src/admin/services/batch-schedule-service';
import GenerateSchedules from '../entrypoints/src/admin/utilities/generate_schedules';

// Column highlight while a card is dragged over it (same look as the calendar drop target).
const DROP_TARGET_CLASSES = ['bg-indigo-50', 'border-indigo-500', 'ring-1', 'ring-inset', 'ring-indigo-500'];
// Saved card whose deactivation waits for the batch form to be submitted.
const PENDING_DEACTIVATION_CLASSES = ['border-dashed', 'border-rose-300'];
// Index placeholder the server leaves in the new-card template (see BatchesHelper#batch_schedule_card_template).
const NEW_CARD_UID_PLACEHOLDER = 'NEW_SCHEDULE_UID';
const DAY_COLUMN_SELECTOR = '.schedule-day[data-week-day]';

export default class extends Controller {
  static targets = [
    'table',
    'showInactives',
    'newCard'
  ];
  static values = { modalTitle: String }

  connect() {
    moment.locale('pt-BR');
    this.bindEvents();
    this.initializeAttributes();

    this.tag = "[BatchSchedules]";
    console.log(this.tag, "Connected");

    if (this.modalGenerateSchedules) {
      this.generateSchedulesTool = new GenerateSchedules(this.modalGenerateSchedules, { onSave: (schedules) => this.saveGeneratedSchedules(schedules) });
      $(this.modalGenerateSchedules).on('keydown',  (ev) => {
        if (ev.code === 'NumpadEnter' || ev.code === 'Enter') {
          ev.preventDefault();
          ev.stopPropagation();
          this.generateSchedulesTool.steppedForm.next();
        }
      });
    }

    if (this.modalHandleSchedule) {
      $(this.modalHandleSchedule).on('shown.bs.modal', () => this.startTime?.focus());
      $(this.modalHandleSchedule).on('hidden.bs.modal', () => this.resetModal());
      $(this.modalHandleSchedule).on('keydown', (ev) => {
        if (ev.code === 'NumpadEnter' || ev.code === 'Enter') {
          ev.preventDefault();
          ev.stopPropagation();
          this.saveSchedule();
        }
      });
    }

    $(document).on('click', '[data-action^="batch-schedules"]', (ev) => {
      ev.preventDefault();
      this[ev.currentTarget.dataset.action.replace('batch-schedules#', '')](ev);
    });

    !!this.hasShowInactivesTarget && this.showInactivesTarget.addEventListener('click', this.toggleInactivesSchedules.bind(this));
  }

  initializeAttributes() {
    if (!this.hasTableTarget) return;
    this.objectName = this.tableTarget.dataset.objectName;
    this.modalHandleSchedule = document.querySelector('#modal-handle-schedule');
    this.modalGenerateSchedules = document.querySelector('#modal-generate-schedules');

    if (!this.modalHandleSchedule) return;
    this.modalTitle = this.modalHandleSchedule.querySelector('.modal-title');
    this.infoMessages = this.modalHandleSchedule.querySelector('#info-messages');
    this.startTime = this.modalHandleSchedule.querySelector('input.start-time');
    this.endTime = this.modalHandleSchedule.querySelector('input.end-time');
    this.enrollmentsAmount = this.modalHandleSchedule.querySelector('#enrollments-amount');
    this.enrollmentsMessage = this.modalHandleSchedule.querySelector('#enrollments-message');
    this.saveScheduleButton = this.modalHandleSchedule.querySelector('button.save-changes');
  }

  toggleInactivesSchedules(ev) {
    this.tableTarget.querySelectorAll('.schedule.disabled').forEach(($el) => {
      $el.classList.toggle('hidden', !this.showInactivesTarget.checked);
    });
  }

  bindEvents() {
    if (!this.hasTableTarget) return;

    $(this.tableTarget).on('click', '.remove-batch-schedule', this.removeSchedule.bind(this));
    this.bindDragAndDrop();
  }

  bindDragAndDrop() {
    this.tableTarget.addEventListener('dragstart', (ev) => {
      const schedule = ev.target.closest('.schedule.active[draggable="true"]');
      if (!schedule) return;

      this.draggingSchedule = schedule;
      ev.dataTransfer.effectAllowed = 'move';
      ev.dataTransfer.setData('text/plain', schedule.dataset.batchScheduleId || '');
      schedule.classList.add('opacity-50', 'cursor-grabbing');
    });

    this.tableTarget.addEventListener('dragend', () => {
      this.draggingSchedule?.classList.remove('opacity-50', 'cursor-grabbing');
      this.tableTarget.querySelectorAll(DAY_COLUMN_SELECTOR).forEach((column) => this.highlightColumn(column, false));
      this.draggingSchedule = null;
    });

    this.tableTarget.addEventListener('dragover', (ev) => {
      if (!this.draggingSchedule) return;

      const column = ev.target.closest(DAY_COLUMN_SELECTOR);
      if (!column) return;

      ev.preventDefault();
      ev.dataTransfer.dropEffect = 'move';
    });

    this.tableTarget.addEventListener('dragenter', (ev) => {
      if (!this.draggingSchedule) return;

      const column = ev.target.closest(DAY_COLUMN_SELECTOR);
      if (!column) return;

      this.tableTarget.querySelectorAll(DAY_COLUMN_SELECTOR).forEach((other) => this.highlightColumn(other, false));
      this.highlightColumn(column, true);
    });

    this.tableTarget.addEventListener('dragleave', (ev) => {
      const column = ev.target.closest(DAY_COLUMN_SELECTOR);
      if (!column || column.contains(ev.relatedTarget)) return;

      this.highlightColumn(column, false);
    });

    this.tableTarget.addEventListener('drop', (ev) => {
      ev.preventDefault();
      if (!this.draggingSchedule) return;

      const targetColumn = ev.target.closest(DAY_COLUMN_SELECTOR);
      if (!targetColumn) return;

      this.highlightColumn(targetColumn, false);

      const newWeekDay     = parseInt(targetColumn.dataset.weekDay, 10);
      const originColumn   = this.draggingSchedule.closest(DAY_COLUMN_SELECTOR);
      const currentWeekDay = originColumn ? parseInt(originColumn.dataset.weekDay, 10) : -1;

      if (newWeekDay === currentWeekDay) return;

      const batchScheduleId = this.draggingSchedule.dataset.batchScheduleId;
      const batchId         = this.draggingSchedule.dataset.batchId;
      // Capture the element reference synchronously before dragend nullifies this.draggingSchedule
      const scheduleElement = this.draggingSchedule;

      const weekDayName = this.weekDayNameFor(newWeekDay);
      this.askQuestion(`Deseja mover este horário para <b>${weekDayName}</b>?<br><small class="text-muted">As aulas futuras serão reagendadas para o novo dia.</small>`).then((result) => {
        if (!result.value) return;

        if (batchScheduleId && batchId) {
          this.persistScheduleMove(batchId, batchScheduleId, newWeekDay, targetColumn, scheduleElement);
        } else {
          this.applyScheduleMoveDOM(scheduleElement, targetColumn, newWeekDay);
        }
      });
    });
  }

  highlightColumn(column, highlighted) {
    DROP_TARGET_CLASSES.forEach((className) => column.classList.toggle(className, highlighted));
  }

  async persistScheduleMove(batchId, batchScheduleId, newWeekDay, targetColumn, schedule) {
    const response = await BatchScheduleService.move(batchId, batchScheduleId, newWeekDay);

    if (response && response.id) {
      this.applyScheduleMoveDOM(schedule, targetColumn, newWeekDay);
      sweet_alert.fire({
        title: 'Pronto',
        text: 'Horário movido! As aulas futuras serão atualizadas.',
        icon: 'success',
        showClass: { backdrop: 'swal2-noanimation', popup: '' },
        hideClass: { popup: '' },
        customClass: { confirmButton: 'btn btn-primary' },
        buttonsStyling: false,
        showCancelButton: false,
        confirmButtonText: 'Ok',
      });
    }
  }

  applyScheduleMoveDOM(schedule, targetColumn, newWeekDay) {
    const weekDayName = this.weekDayNameFor(newWeekDay);
    targetColumn.querySelector('.schedule-cards').appendChild(schedule);
    schedule.dataset.weekName = weekDayName;

    const weekDayInput = schedule.querySelector("input[name*='[week_day]']");
    if (weekDayInput) weekDayInput.value = newWeekDay;
    this.refreshDayCounts();
  }

  weekDayNameFor(weekDay) {
    const link = this.tableTarget.querySelector(`${DAY_COLUMN_SELECTOR.replace(']', `="${weekDay}"]`)} a[data-week-day-name]`);
    return link?.dataset.weekDayName ?? '';
  }

  dayCardsContainer(weekDay) {
    return this.tableTarget.querySelector(`.schedule-day[data-week-day="${weekDay}"] .schedule-cards`);
  }

  // Column header counters: active cards still in play (a card pending deactivation is not counted);
  // an empty column falls back to the label the server rendered ("—" or "N inativos").
  refreshDayCounts() {
    this.tableTarget.querySelectorAll(DAY_COLUMN_SELECTOR).forEach((column) => {
      const counter = column.querySelector('[data-day-count]');
      if (!counter) return;

      const activeCards = column.querySelectorAll('.schedule.active:not(.disabled)').length;
      counter.textContent = activeCards > 0 ? activeCards : counter.dataset.emptyLabel;
    });
  }

  openHandleSchedules() {
    $(this.modalHandleSchedule).modal('hide');
    $(this.modalGenerateSchedules).modal('show')
  }

  saveGeneratedSchedules(schedules) {
    const container = this.dayCardsContainer(this.weekDay);
    schedules.forEach((schedule) => {
      container.appendChild(this.buildScheduleCard(schedule));
    });
    this.refreshDayCounts();

    $(this.modalGenerateSchedules).modal('hide');
  }

  formatTime(time) {
    if (typeof time === 'string')
      return time;

    return moment(time).format('HH:mm');
  };

  validateSchedule() {
    $(this.infoMessages).addClass('hidden').html('');

    let times = [];
    [this.startTime, this.endTime].forEach((target) => {
      let formGroup = target.closest('.form-group'),
        parsedTime = moment(target.value, 'HH:mm');
      formGroup.classList.remove('has-error', 'has-success');
      formGroup.classList.add((isEmpty(target.val) || !parsedTime.isValid()) ? 'has-error' : 'has-success');
      times.push(parsedTime);
    });

    if ((!isEmpty(times[0]) && !isEmpty(times[1])) && times[0].isBefore(times[1])) {
      return {
        startTime: times[0].format('HH:mm'),
        endTime: times[1].format('HH:mm')
      };
    } else {
      $(this.infoMessages).removeClass('hidden').addClass('text-danger').html('Horário inicial precisa ser antes do final!');
      $(this.modalHandleSchedule).find('div.form-group').removeClass('has-error has-success').addClass('has-error');
    }
  }

  resetModal() {
    $(this.modalHandleSchedule).find('.form-group').removeClass('has-success has-error');
    $(this.modalHandleSchedule).find('input').val('');
    this.$schedule = this.batchId = this.batchScheduleId = undefined;
    this.saveScheduleButton.removeAttribute('disabled');
  }

  // Clones the server-rendered "new schedule" card so unsaved cards look like the saved ones; the
  // placeholder index becomes a unique one so every card lands in its own schedules_attributes entry.
  buildScheduleCard(schedule) {
    const uid = `${(new Date()).getTime() + Math.ceil(Math.random()*1000)}${this.weekDay}`;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = this.newCardTarget.innerHTML.split(NEW_CARD_UID_PLACEHOLDER).join(uid);
    const card = wrapper.querySelector('.schedule');

    const startTime = this.formatTime(schedule.startTime);
    const endTime = this.formatTime(schedule.endTime);
    card.querySelector("input[name$='[start_time]']").value = startTime;
    card.querySelector("input[name$='[end_time]']").value = endTime;
    card.querySelector("input[name$='[week_day]']").value = this.weekDay;
    card.querySelector('.batch-schedule-time').textContent = `${startTime} – ${endTime}`;
    card.dataset.startTime = startTime;
    card.dataset.endTime = endTime;
    card.dataset.weekName = this.weekDayName;

    return card;
  };

  askQuestion(question) {
    return sweet_alert.fire({
      title: 'Atenção',
      html: question,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    });
  }

  async updateSchedule() {
    let response = await BatchScheduleService.edit(this.batchId, this.batchScheduleId, {
      'start_time': this.startTime.value,
      'end_time': this.endTime.value
    });

    if (!!response && !!response.id) {
      this.$schedule.dataset.startTime = this.startTime.value;
      this.$schedule.dataset.endTime = this.endTime.value;
      this.$schedule.querySelector("[name*='start_time']").value = this.startTime.value;
      this.$schedule.querySelector("[name*='end_time']").value = this.endTime.value;
      this.$schedule.querySelector('.batch-schedule-time').textContent = `${this.startTime.value} – ${this.endTime.value}`;
      sweet_alert.fire({
        title: 'Pronto',
        text: 'Horário alterado com sucesso!',
        showClass: { backdrop: 'swal2-noanimation', popup: '', },
        hideClass: { popup: '' },
        customClass: {
          cancelButton: 'btn btn-gray-primary',
          confirmButton: 'btn btn-primary mr-3'
        },
        buttonsStyling: false,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: 'Ok'
      });
      $(this.modalHandleSchedule).modal('hide');
    }
  }

  // events
  newSchedule(ev) {
    let $el = ev.currentTarget;
    this.weekDayName = $el.dataset.weekDayName;
    this.weekDay = $el.dataset.weekDay;
    this.modalTitleValue = `Adicionar Horário - ${this.weekDayName}`;
    this.enrollmentsMessage.classList.toggle('hidden', true);
    $(this.modalHandleSchedule).modal('show');
  }

  generateSchedules(ev) {
    let $el = ev.currentTarget;
    this.weekDayName = $el.dataset.weekDayName;
    this.weekDay = $el.dataset.weekDay;
    $(this.modalGenerateSchedules).modal('show');
  }

  editSchedule(ev) {
    this.$schedule = ev.currentTarget.closest('.schedule');
    this.weekDayName = this.$schedule.dataset.weekName;
    this.batchId = this.$schedule.dataset.batchId;
    this.batchScheduleId = this.$schedule.dataset.batchScheduleId;

    this.modalTitleValue = `Alterar Horário - ${this.weekDayName}`;
    this.startTime.value = this.$schedule.dataset.startTime;
    this.endTime.value = this.$schedule.dataset.endTime;
    this.enrollmentsAmount.innerHTML = this.$schedule.dataset.enrollmentsAmount;
    this.enrollmentsMessage.classList.toggle('hidden', +this.$schedule.dataset.enrollmentsAmount == 0);
    $(this.modalHandleSchedule).modal('show');
  };

  saveSchedule() {
    let schedule = this.validateSchedule();

    if (!schedule)
      return;

    this.saveScheduleButton.setAttribute('disabled', '');
    if (!!this.batchScheduleId)
      return this.updateSchedule();

    this.dayCardsContainer(this.weekDay).appendChild(this.buildScheduleCard(schedule));
    this.refreshDayCounts();
    $(this.modalHandleSchedule).modal('hide');
  };

  removeSchedule(ev) {
    let $divBatchSchedule = ev.currentTarget.closest('.schedule'),
      $el = $divBatchSchedule.querySelector("input[type=hidden][name$='[id]']"),
      isNewBatchSchedule = !$el || isEmpty($el.value);

    if ($divBatchSchedule.classList.contains('disabled'))
      return;

    this.askQuestion('Deseja realmente desativar esse horário?').then((result) => {
      if (!result.value) return;

      if (isNewBatchSchedule) {
        $divBatchSchedule.remove();
        this.refreshDayCounts();
        return;
      }

      $divBatchSchedule.querySelector('.disable').value = 'true';
      $divBatchSchedule.querySelector('.reactivate-batch-schedule').classList.toggle('hidden', false);
      $divBatchSchedule.querySelector('.remove-batch-schedule').classList.toggle('hidden', true);
      $divBatchSchedule.querySelector('.pending-deactivation').classList.toggle('hidden', false);
      $divBatchSchedule.classList.add('disabled', ...PENDING_DEACTIVATION_CLASSES);
      this.refreshDayCounts();
    });
  }

  reactivateSchedule(ev) {
    let $target = ev.currentTarget,
      $divBatchSchedule = $target.closest('.schedule');

    if (!$divBatchSchedule.classList.contains('disabled'))
      return;

    this.askQuestion('Deseja realmente reativar esse horário?').then(async (result) => {
      if (!result.value)
        return;

      if (!!$target.dataset.batchId && $target.dataset.batchScheduleId) {
        let response = await BatchScheduleService.activate($target.dataset.batchId, $target.dataset.batchScheduleId);

        if (!!response && !!response.id) {
          sweet_alert.fire({
            title: 'Pronto',
            icon: 'success',
            text: 'Horário reativado com sucesso!',
            showClass: { backdrop: 'swal2-noanimation', popup: '', },
            hideClass: { popup: '' },
            customClass: {
              cancelButton: 'btn btn-gray-primary',
              confirmButton: 'btn btn-primary mr-3'
            },
            buttonsStyling: false,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: 'Ok'
          });
        }

        return;
      }

      $divBatchSchedule.querySelector('.disable').value = 'false';
      $divBatchSchedule.classList.remove('disabled', ...PENDING_DEACTIVATION_CLASSES);
      $divBatchSchedule.querySelector('.remove-batch-schedule').classList.toggle('hidden', false);
      $divBatchSchedule.querySelector('.reactivate-batch-schedule').classList.toggle('hidden', true);
      $divBatchSchedule.querySelector('.pending-deactivation').classList.toggle('hidden', true);
      this.refreshDayCounts();
    });
  }

  // callbacks
  modalTitleValueChanged() {
    if (!this.modalTitle)
      return;

    this.modalTitle.innerHTML = this.modalTitleValue;
  }
}
